/**
 * Search Presentation Images Tool Schema
 *
 * Semantic search within presentation deck for images.
 */
import { z } from "zod";
// ═══════════════════════════════════════════════════════════════════════════
// PARAMS SCHEMA
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Deck ID can be numeric index, "CURRENT", or explicit deck ID
 */
export const documentIdSchema = z.union([
    z.number().int().min(0),
    z.literal("CURRENT"),
    z.string().min(1),
]).describe("Deck index (from PowerPoint File Index Registry), 'CURRENT', or explicit deck ID");
/**
 * Search Presentation Images parameters
 */
export const SearchPresentationImagesParamsSchema = z.object({
    uiDescription: z.string()
        .describe("Brief description (max ~15 words) of what this tool call is attempting."),
    documentId: documentIdSchema
        .describe("Deck to search: numeric index, 'CURRENT', or deck ID"),
    query: z.string()
        .min(1, "Query cannot be empty")
        .describe("Semantic search query (e.g., 'Deutsche Bank logo')"),
    limit: z.number()
        .int()
        .min(1)
        .max(50)
        .optional()
        .default(10)
        .describe("Maximum number of results to return (default: 10)"),
});
